import { prop, useHeroData } from '@/hero/data';
import { useSelectionStore } from '@/state/selection';
import { hero, stations, useTourStore } from '@/state/tour';
import { stationImpl } from '@/stations';

const QUICK: [string, string, string][] = [
  ['PSet_Revit_Dimensions', 'Area', 'm²'],
  ['PSet_Revit_Dimensions', 'Length', 'm'],
  ['PSet_Revit_Dimensions', 'Volume', 'm³'],
  ['PSet_Revit_Type_Dimensions', 'Width', 'm'],
  ['PSet_Revit_Type_Dimensions', 'Height', 'm'],
  ['Pset_WallCommon', 'IsExternal', ''],
  ['Pset_WallCommon', 'LoadBearing', ''],
  ['Pset_DoorCommon', 'FireRating', ''],
  ['PSet_Revit_Identity Data', 'Number', ''],
  ['PSet_Revit_Identity Data', 'Name', ''],
  ['PSet_Revit_Type_Identity Data', 'OmniClass Title', ''],
];

export function ElementCard() {
  const selected = useSelectionStore((s) => s.selected);
  const select = useSelectionStore((s) => s.select);
  const activeIndex = useTourStore((s) => s.activeIndex);
  const data = useHeroData((s) => s.data);
  const impl = stationImpl(stations[activeIndex]!.kind);
  if (!selected || impl.ownsSelection) return null;

  const el = data?.byId.get(selected.expressID);
  const layer = hero.layers.find((l) => l.id === selected.layer);
  const rows = el
    ? QUICK.map(([ps, name, unit]) => {
        const v = prop(el, ps, name);
        if (v == null) return null;
        const n = Number(v);
        return { name, value: Number.isFinite(n) && unit ? `${n.toFixed(2)} ${unit}` : v };
      }).filter((r): r is { name: string; value: string } => r != null)
    : [];
  const Extra = impl.Card;

  return (
    <div className="lens-panel card">
      <div className="lens-bar">
        <span className="lens-dot" />
        <span>{layer?.label ?? layer?.discipline ?? 'element'}</span>
        <button
          className="lens-close"
          type="button"
          onClick={() => select(null)}
          aria-label="Close"
        >
          ×
        </button>
      </div>
      <div className="rb-head">
        <span className="rb-type">{el?.type ?? '–'}</span>
        <span className="rb-name">{el?.name ?? `#${selected.expressID}`}</span>
        <span className="rb-meta">
          {el?.storey ?? '–'} · #{selected.expressID}
          {el?.globalId ? ` · ${el.globalId}` : ''}
        </span>
      </div>
      {rows.length > 0 && (
        <dl className="kv">
          {rows.slice(0, 5).map((r) => (
            <div key={r.name}>
              <dt>{r.name}</dt>
              <dd>{r.value}</dd>
            </div>
          ))}
        </dl>
      )}
      {Extra && <Extra selection={selected} element={el} />}
    </div>
  );
}
